<cl-sub-toolbar>
    <nav-toolbar currentTitleOverride="Device Search"></nav-toolbar>
    <div style="flex: 1 1 auto;"></div>
    <div>
        <button mat-button (click)="toggleMap()">
            <mat-icon>map</mat-icon>
            TOOGLE MAP
        </button>
    </div>
</cl-sub-toolbar>

<div fxLayout="column" fxFlexFill class="top-space">
    <div *ngIf="isReady" fxFlexFill>
        <dl-device-status-grid
                fxFlexFill
                [locationId]="locationId"
                [jobNumber]="jobNumber"
                [isMapEnabled]="isMapEnabled">
        </dl-device-status-grid>
    </div>
</div>
